import {
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
} from 'store/updateDoctorProfile/updateDoctorProfileAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const updateProfileSectionDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE:
      return { ...state, loading: true };
    case UPDATE_PROFILE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case UPDATE_PROFILE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default updateProfileSectionDataReducer;
